import { Autocomplete, AutocompleteItem, Input, MenuTriggerAction, Select, SelectItem } from '@nextui-org/react'
import React, { useEffect, useState } from 'react'
import { useFormCampaignContext } from '../hooks/useFormCampaignContext'
import { useFilter } from '@react-aria/i18n'
import { FormCampaignContextType } from '../context/FormCampaignContext'

export type FieldState = {
  selectedKey: React.Key | null;
  inputValue: string;
  buyList: any[]
};

const FormStep1 = ({ className, onChange }: any) => {
  const { ctx, saveCtx } = useFormCampaignContext() as FormCampaignContextType
  // Filtrar buyList para asegurar que todos tengan id definido
  const validBuyList = Array.isArray(ctx.buyList)
    ? ctx.buyList.filter(item => item && item.id !== undefined && item.id !== null)
    : []
  const [fieldState, setFieldState] = useState<FieldState>({
    selectedKey: '',
    inputValue: '',
    buyList: validBuyList
  })
  console.log('fieldState ctx.buyList => ', fieldState, ctx.buyList)
  const { startsWith } = useFilter({ sensitivity: 'base' })

  const onSelectionChange = (id: React.Key | null) => {
    console.log('id onSelectionChange ==> ', id)
    if (id === null) return
    setFieldState((prevState) => {
      console.log('prevState ==> ', prevState, validBuyList)
      const selectedItem = validBuyList.find((option) => Number(option.id) === Number(id))
      console.log('selectedItem ==> ', selectedItem)

      return {
        inputValue: selectedItem?.name || '',
        selectedKey: id,
        buyList: validBuyList
      }
    })
  }

  // Specify how each of the Autocomplete values should change when the input
  // field is altered by the user
  const onInputChange = (value: string) => {
    console.log('value ==> ', value)
    setFieldState((prevState) => {
      console.log('prevState ==> ', prevState)
      // Try to find a match in the buyList
      const matchingItem = validBuyList.find(item =>
        startsWith(item.name.toLowerCase(), value.toLowerCase())
      )
      console.log('matchingItem ==> ', matchingItem)

      return {
        inputValue: value,
        selectedKey: matchingItem ? matchingItem.id : (value === '' ? null : prevState.selectedKey),
        buyList: validBuyList
      }
    })
  }

  // Show entire list if user opens the menu manually
  const onOpenChange = (isOpen: boolean, menuTrigger: MenuTriggerAction) => {
    console.log('isOpen ==> ', isOpen)
    if (menuTrigger === 'manual' && isOpen) {
      setFieldState((prevState) => ({
        inputValue: prevState.inputValue,
        selectedKey: prevState.selectedKey,
        buyList: validBuyList
      }))
    }
  }

  useEffect(() => {
    saveCtx({ ...ctx, form: { ...ctx.form, buy: fieldState.inputValue } })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldState.inputValue])

  useEffect(() => {
    console.log('ctx ==> ', ctx)
    if (Number(ctx.form.buy) > 0 && ctx.form.scope === 'BUY') {
      console.log('ctx.form.buy ==> ', ctx.form.buy)
      const selectedItem = validBuyList.find(item => Number(item.id) === Number(ctx.form.buy))

      console.log('selectedItem ==> ', selectedItem)

      if (selectedItem) {
        setFieldState({
          selectedKey: String(selectedItem.id),
          inputValue: selectedItem.name,
          buyList: validBuyList
        })
      } else {
        setFieldState({
          selectedKey: '',
          inputValue: '',
          buyList: validBuyList
        })
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.form.buy])

  return (
    <div className={`w-full space-y-2 py-5 ${className || ''}`}>
      <div className='grid grid-cols-2 gap-4 max-w-3xl mx-auto'>
        <div className='col-span-2'>
          <Input
            label='Nombre de la campaña'
            placeholder='Ej: Promo Primavera'
            value={ctx.form.name}
            onChange={(e) => onChange('name', e.target.value)}
            isRequired
          />
        </div>
        <div>
          <Select
            label='Tipo de campaña'
            selectedKeys={[ctx.form.scope]}
            onChange={(e) => onChange('scope', e.target.value)}
          >
            <SelectItem key='SBU'>Por SBU</SelectItem>
            <SelectItem key='BRAND'>Por Marca</SelectItem>
            <SelectItem key='MODEL'>Por Modelo</SelectItem>
            <SelectItem key='BUY'>Por Compra especifica</SelectItem>
          </Select>
        </div>

        {(ctx.form.scope === 'BUY') && (
          <div>
            <Autocomplete
              allowsCustomValue
              defaultItems={validBuyList}
              inputValue={fieldState.inputValue}
              selectedKey={fieldState.selectedKey as any}
              label='Asigne nombre de compra'
              placeholder='Buscar dispositivo o marca'
              onInputChange={onInputChange}
              onOpenChange={onOpenChange}
              onSelectionChange={onSelectionChange}
            >
              {(item) => <AutocompleteItem key={item.id ?? `no-id-${item.name}`}>{item.name}</AutocompleteItem>}
            </Autocomplete>
          </div>
        )}
        {(ctx.form.scope !== 'BUY') && (
          <div>
            <Select
              label='Selecciona SBU'
              selectedKeys={[ctx.form.sbuId]}
              onChange={(e) => onChange('sbuId', e.target.value)}
            >
              {ctx.sbuList.map((s: any) => (
                <SelectItem key={s.id_sbu}>{s.device}</SelectItem>
              ))}
            </Select>
          </div>
        )}
        <div>
          {(ctx.form.scope === 'BRAND' || ctx.form.scope === 'MODEL') && (
            <Select
              isLoading={ctx.loading}
              label='Selecciona Marca'
              selectedKeys={[ctx.form.brandId]}
              onChange={(e) => onChange('brandId', e.target.value)}
            >
              {ctx.brandList.map((b: any) => (
                <SelectItem key={b.id_brand}>{b.brand}</SelectItem>
              ))}
            </Select>
          )}
        </div>
        <div>
          {ctx.form.scope === 'MODEL' && (
            <Select
              isLoading={ctx.loading}
              label='Selecciona Modelo'
              selectedKeys={[ctx.form.modelId]}
              onChange={(e) => onChange('modelId', e.target.value)}
              isDisabled={!ctx.form.brandId}
            >
              {ctx.modelList.map((m: any) => (
                <SelectItem key={m.id_model}>{m.model}</SelectItem>
              ))}
            </Select>
          )}
        </div>
      </div>
    </div>
  )
}

export default FormStep1
